import {useEffect} from "react";
import {useLocation} from "wouter";
export const isMaintenancePath=(path:string)=>path==="/maintenance"||path.startsWith("/maintenance/");
/** A distinct install identity; the existing full-Infrastock manifest is unchanged. */
export function syncMaintenanceInstallMetadata(path:string){
 const maintenance=isMaintenancePath(path),head=document.head;
 let manifest=head.querySelector<HTMLLinkElement>('link[rel="manifest"]');
 if(!manifest){manifest=document.createElement("link");manifest.rel="manifest";head.appendChild(manifest)}
 manifest.setAttribute("href",maintenance?"/maintenance.webmanifest":"/manifest.webmanifest");
 head.querySelectorAll('link[rel="manifest"]').forEach(link=>{if(link!==manifest)link.remove()});
 const title=head.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
 if(title)title.content=maintenance?"Infrastock Maintenance":"Infrastock";
 const icon=head.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
 if(icon)icon.href=maintenance?"/maintenance-icon-192.png":"/apple-touch-icon.png";
}
export function MaintenanceInstallMetadata(){
 const [path]=useLocation();
 useEffect(()=>{syncMaintenanceInstallMetadata(path)},[path]);
 return null;
}
